import { Box, BoxProps } from "@mui/material";
import { KeyValue } from "~/lib/types";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { useColorMode } from "~/providers/color-mode";

type KeyValueChipProps = {
  keyValue: KeyValue;
  onDelete?: BoxProps["onClick"];
};

export function KeyValueChip({ keyValue, onDelete }: KeyValueChipProps) {
  const { key, value } = keyValue;
  const label = `${key} ${value}`;
  const { mode } = useColorMode();

  const chipSx = {
    display: "inline-flex",
    alignItems: "center",
    border: "1px solid",
    borderColor: "background.light",
    backgroundColor: "background.light",
    marginTop: 1,
    marginRight: 1,
    paddingRight: 1,
    borderRadius: 1,
    typography: "body2",
    cursor: "pointer",
    fontSize: "13px",
    overflowWrap: "anywhere",
  };
  const keySx = {
    backgroundColor: "background.paper",
    padding: 1,
    display: "inline-flex",
    alignSelf: "stretch",
    alignItems: "center",
  };
  const valSx = {
    backgroundColor: "background.light",
    padding: 1,
    display: "inline-flex",
    alignSelf: "stretch",
    alignItems: "center",
  };
  return (
    <Box sx={chipSx} onClick={onDelete} aria-label={label}>
      <Box sx={keySx}>{key}</Box>
      <Box sx={valSx}>{value}</Box>
      <CancelIcon
        sx={{
          color: "text.primary",
          opacity: "0.26",
          ...(mode === "light" ? { ml: 1 } : {}),
        }}
      />
    </Box>
  );
}
